import {SECONDS_IN_MINUTE} from './constants';

export const MIN_STAMP_POSITION = 5;
export const MAX_STAMP_POSITION = 90;
export const PERCENT_RATE = 100;
export const EXPIRED_TIME_INDENT = 10;
export const MIN_EXPIRED_TIME_STAMP_POSITION = 15;

export const MAX_INTERVAL_COUNT = 4;
export const MAX_INTERVAL_TIME_IN_MINUTES = 5;
export const MAX_INTERVAL_TIME_IN_SECONDS =
  MAX_INTERVAL_TIME_IN_MINUTES * SECONDS_IN_MINUTE;

export enum ProgressBarState {
  NORMAL = 'NORMAL',
  ALERT = 'ALERT',
  EXPIRED = 'EXPIRED'
}

export enum ProgressBarColor {
  DEFAULT = 'default',
  DEFAULT_CURRENT_TASK = 'default-current-task',
  ALERT_RANGE = 'alert-range',
  EXPIRED = 'expired'
}
